export const APP_BRAND_NAME = 'nabomba.com'
export const APP_BRAND_FULL_NAME = 'nabomba.com - Desconto em Combustivel'
export const APP_BRAND_MARK_SRC = '/brand/whats-fidelidade-mark.png'
export const APP_BRAND_WORDMARK_SRC = '/brand/whats-fidelidade-wordmark.png'
export const APP_BRAND_WORDMARK_DARK_SRC = '/brand/whats-fidelidade-wordmark-dark.png'
export const APP_BRAND_ICON_192_SRC = '/brand/whats-fidelidade-icon-192.png'
export const APP_BRAND_ICON_512_SRC = '/brand/whats-fidelidade-icon-512.png'
export const APP_BRAND_ICON_512_MASKABLE_SRC = '/brand/whats-fidelidade-icon-512-maskable.png'
export const APP_BRAND_TOUCH_ICON_SRC = '/brand/whats-fidelidade-apple-touch-icon.png'
export const APP_BRAND_FAVICON_96_SRC = APP_BRAND_MARK_SRC
export const APP_BRAND_FAVICON_ICO_SRC = '/brand/whats-fidelidade-favicon.ico'
